<div class="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="appVersionModalTitle">
  <div class="modal-box app-version-modal-box">
    <!-- Modal Header -->
    <div class="modal-header" [attr.inert]="showDeleteDialog ? '' : null" [attr.aria-hidden]="showDeleteDialog ? 'true' : null">
      <div class="modal-title-group">
        <h3 id="appVersionModalTitle" tabindex="-1">Manage CoinSing Versions</h3>
        <p class="modal-subtitle" *ngIf="selectedDeviceCount > 0">
          Targeting <strong>{{ selectedDeviceCount }}</strong> selected {{ selectedDeviceCount === 1 ? 'device' : 'devices' }}
        </p>
      </div>
      <button type="button" class="close-btn" (click)="closeModal()" aria-label="Close dialog" [disabled]="isReleasing || isDeleting">×</button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body" [attr.inert]="showDeleteDialog ? '' : null" [attr.aria-hidden]="showDeleteDialog ? 'true' : null">
      <!-- Targeted Mode Banner (AC-4) -->
      <div class="targeted-release-banner" *ngIf="selectedDeviceCount > 0">
        <div class="banner-text">
          <span class="banner-icon">🎯</span>
          <span>Targeted Mode: Releasing a version here will ONLY publish and update the <strong>{{ selectedDeviceCount }}</strong> selected {{ selectedDeviceCount === 1 ? 'device' : 'devices' }}.</span>
        </div>
        <button type="button" class="btn-clear-selection" (click)="onClearSelection()">Clear Selection</button>
      </div>

      <!-- Result Panel (AC-9) -->
      <div class="result-panel" role="status" *ngIf="showResultPanel && resultOutcome">
        <div class="result-panel-header">
          <div class="result-title-group">
            <span class="result-icon">📊</span>
            <strong>Release Results — v{{ resultOutcome.version }}</strong>
          </div>
          <button type="button" class="result-close-btn" (click)="closeResultPanel()" aria-label="Dismiss results">✕</button>
        </div>
        <div class="result-summary">
          <span class="result-stat success-stat">✅ {{ resultOutcome.counts.accepted }} Succeeded</span>
          <span class="result-stat failed-stat" *ngIf="resultOutcome.counts.failed > 0">❌ {{ resultOutcome.counts.failed }} Failed</span>
          <span class="result-stat skipped-stat" *ngIf="resultOutcome.counts.skipped > 0">⚠️ {{ resultOutcome.counts.skipped }} Skipped</span>
          <span class="result-stat rollback-stat" *ngIf="resultOutcome.counts.rollbacks > 0">↩ {{ resultOutcome.counts.rollbacks }} Rollbacks</span>
        </div>

        <!-- Failed Devices List & Retry -->
        <div class="failed-list-section" *ngIf="failedDeviceResults.length > 0">
          <p class="failed-list-title">Failed Devices:</p>
          <ul class="failed-devices-list">
            <li *ngFor="let f of failedDeviceResults">
              <strong>{{ f.deviceId }}</strong>: {{ f.reason || 'Update failed' }}
            </li>
          </ul>
          <button type="button" class="btn-retry-failed" (click)="retryFailedDevices()" [disabled]="isReleasing">
            <span *ngIf="!isReleasing">🔁 Retry failed ({{ failedDeviceResults.length }})</span>
            <span *ngIf="isReleasing"><span class="spinner-small"></span> Retrying...</span>
          </button>
        </div>
      </div>

      <!-- KAN-578: delete feedback (in-modal, the page toast sits behind the overlay) -->
      <div class="alert-success" role="status" data-testid="delete-success" *ngIf="deleteSuccessMessage">
        {{ deleteSuccessMessage }}
      </div>
      <div class="alert-warning" role="status" data-testid="delete-audit-warning" *ngIf="deleteAuditWarning">
        {{ deleteAuditWarning }}
      </div>
      <div class="alert-info" role="status" data-testid="delete-info" *ngIf="deleteInfoMessage">
        {{ deleteInfoMessage }}
      </div>

      <!-- Error Alert -->
      <div class="alert-error" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="spinner"></div>
        <p class="loading-text">Loading CoinSing releases...</p>
      </div>

      <!-- Versions Table -->
      <div class="table-scrollable" *ngIf="!isLoading">
        <table class="data-table">
          <thead>
            <tr>
              <th>Version</th>
              <th>Published At</th>
              <th>Published By</th>
              <th class="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ver of appVersionsList; let i = index" [class.invalid-version-row]="!ver.isValid"
                [class.deleting-version-row]="isDeletingRow(ver)" [class.row-removing]="removingVersion === ver.version">
              <!-- Version Column -->
              <td>
                <div class="version-cell">
                  <strong class="version-text">v{{ ver.version }}</strong>
                  <span *ngIf="i === 0 && ver.isValid" class="version-latest-badge">Latest</span>
                  <span *ngIf="!ver.isValid" class="version-invalid-badge">Not a valid version</span>
                  <span *ngIf="isDeletingRow(ver)" class="version-deleting-badge" data-testid="deleting-badge">Deleting...</span>
                </div>
              </td>

              <!-- Published At Column -->
              <td>
                {{ ver.publishedAt ? (ver.publishedAt.toDate ? (ver.publishedAt.toDate() | date:'medium') : (ver.publishedAt | date:'medium')) : 'N/A' }}
              </td>

              <!-- Published By Column -->
              <td>
                {{ ver.publishedBy || 'Unknown' }}
              </td>

              <!-- Actions Column -->
              <td class="col-actions">
                <div class="version-row-actions">
                  <button type="button" class="btn-action-notes" *ngIf="!isDeletingRow(ver)" (click)="openReleaseNotes(ver)" title="View / Edit Release Notes for Version {{ ver.version }}">
                    📝 Release Notes
                  </button>

                  <!-- Split Release Button (Only with permission and valid version) -->
                  <div class="split-release-btn-group" *ngIf="canReleaseThisVersion(ver) && !isDeletingRow(ver)">
                    <button type="button" class="btn-split-main"
                            (click)="initiateRelease(ver, false, selectedDeviceCount === 0)"
                            [disabled]="isReleasing"
                            [title]="selectedDeviceCount > 0 ? ('Release v' + ver.version + ' to ' + selectedDeviceCount + ' selected device(s)') : 'Release this version to all active kiosks'">
                      <span *ngIf="selectedDeviceCount > 0">🚀 Release to Selected ({{ selectedDeviceCount }})</span>
                      <span *ngIf="selectedDeviceCount === 0">🚀 Release to All</span>
                    </button>
                    <button type="button" class="btn-split-arrow"
                            (click)="toggleDropdown(ver.version, $event)"
                            [disabled]="isReleasing"
                            title="More release options">
                      ▼
                    </button>

                    <!-- Force Release Dropdown Menu -->
                    <div class="split-dropdown-menu" *ngIf="openDropdownVersion === ver.version" (click)="$event.stopPropagation()">
                      <button type="button" class="dropdown-item-force"
                              (click)="initiateRelease(ver, true, selectedDeviceCount === 0)"
                              [disabled]="isReleasing"
                              [title]="selectedDeviceCount > 0 ? ('Force redownload and reinstall for ' + selectedDeviceCount + ' selected device(s)') : 'Force redownload and reinstall for all kiosks'">
                        <span *ngIf="selectedDeviceCount > 0">⚡ Force Release to Selected ({{ selectedDeviceCount }})</span>
                        <span *ngIf="selectedDeviceCount === 0">⚡ Force Release to All</span>
                      </button>
                    </div>
                  </div>

                  <!-- KAN-578: Delete (hidden without konobox-management_release-delete and on invalid-grammar rows) -->
                  <div class="row-action-danger-zone" *ngIf="canShowDelete(ver)">
                    <button type="button" class="btn-action-delete"
                            (click)="openDeleteDialog(ver, $event)"
                            [disabled]="isReleasing || isDeleting"
                            [attr.aria-label]="(isDeletingRow(ver) ? 'Retry delete of version ' : 'Delete version ') + ver.version"
                            [title]="(isDeletingRow(ver) ? 'Retry delete of version ' : 'Delete version ') + ver.version"
                            [attr.data-testid]="'btn-delete-version-' + ver.version">
                      <svg class="icon-trash" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                           stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                        <path d="M3 6h18"></path>
                        <path d="M8 6V4h8v2"></path>
                        <path d="M19 6l-1 14H6L5 6"></path>
                        <path d="M10 11v6"></path>
                        <path d="M14 11v6"></path>
                      </svg>
                      <span>{{ isDeletingRow(ver) ? 'Retry delete' : 'Delete' }}</span>
                    </button>
                  </div>
                </div>
              </td>
            </tr>

            <!-- Empty State -->
            <tr *ngIf="appVersionsList.length === 0">
              <td colspan="4" class="empty-table-cell">
                No released versions. Publish one with <code>publish_coinsing_release.ps1</code>.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pinned Footer -->
    <div class="modal-footer" [attr.inert]="showDeleteDialog ? '' : null" [attr.aria-hidden]="showDeleteDialog ? 'true' : null">
      <button type="button" class="btn-cancel" (click)="closeModal()" [disabled]="isReleasing || isDeleting">
        Close
      </button>
    </div>

    <!-- KAN-578: Delete a released version (typed confirmation) -->
    <div class="alertdialog-backdrop delete-backdrop" *ngIf="showDeleteDialog && deleteTarget">
      <div class="alertdialog-box delete-dialog-box" role="alertdialog" aria-modal="true"
           aria-labelledby="deleteDialogTitle" aria-describedby="deleteDialogDesc"
           [attr.aria-busy]="isDeleting ? 'true' : null"
           data-testid="delete-dialog" (keydown)="onDeleteDialogKeydown($event)">
        <div class="alertdialog-header">
          <h4 id="deleteDialogTitle" class="rollback-title">
            {{ isDeleteFinishMode ? 'Finish deleting CoinSing v' + deleteTarget.version + '?' : 'Delete CoinSing v' + deleteTarget.version + '?' }}
          </h4>
        </div>

        <div class="alertdialog-body">
          <p id="deleteDialogDesc" class="rollback-copy">
            <ng-container *ngIf="isDeleteFinishMode">A previous delete did not finish. Retrying removes the remaining files and the catalog entry.</ng-container>
            <ng-container *ngIf="!isDeleteFinishMode">This permanently removes the package from Firebase Storage and the release catalog. This cannot be undone.</ng-container>
          </p>

          <div class="delete-blocker" role="alert" data-testid="delete-blocker" *ngIf="isDeleteBlocked">
            <strong>Cannot delete v{{ deleteTarget.version }}.</strong> {{ deleteBlockedMessage }}
            <ul class="blocker-devices" tabindex="0" aria-label="Blocking devices" *ngIf="deleteBlockedDevices.length > 0">
              <li *ngFor="let d of visibleBlockedDevices">{{ deviceLabelOf(d) }}</li>
              <li *ngIf="hiddenBlockedDeviceCount > 0">and {{ hiddenBlockedDeviceCount }} more</li>
            </ul>
          </div>

          <dl class="delete-facts">
            <dt>Version</dt>
            <dd class="mono">v{{ deleteTarget.version }}</dd>
            <dt>Environment</dt>
            <dd>
              <span class="env-badge"
                    [class.env-badge-prod]="deleteEnvBadge.kind === 'prod'"
                    [class.env-badge-dev]="deleteEnvBadge.kind === 'dev'"
                    data-testid="delete-env-badge">{{ deleteEnvBadge.label }}</span>
            </dd>
            <dt>Published</dt>
            <dd>
              <ng-container *ngIf="deletePublishedAt; else pubUnknown">{{ deletePublishedAt | date:'medium' }}</ng-container>
              <ng-template #pubUnknown>Unknown</ng-template>
              by {{ deleteTarget.publishedBy || 'Unknown' }}
            </dd>
            <dt>Size</dt>
            <dd>{{ deleteSizeText }}</dd>
            <dt>Devices running this version</dt>
            <dd>{{ deleteImpact.runningCount === 0 ? 'None' : deleteImpact.runningCount }}</dd>
          </dl>

          <ng-container *ngIf="!isDeleteBlocked">
            <p class="delete-warning" data-testid="delete-warning-running" *ngIf="deleteRunningWarning">{{ deleteRunningWarning }}</p>
            <p class="delete-warning" data-testid="delete-warning-only" *ngIf="deleteOnlyVersion">{{ deleteOnlyWarning }}</p>
          </ng-container>

          <div class="delete-scope delete-scope-removed">
            <h5>Will be removed</h5>
            <ul>
              <li>Package file (zip) in Firebase Storage</li>
              <li>Manifest file in Firebase Storage</li>
              <li>Catalog entry for v{{ deleteTarget.version }}</li>
            </ul>
          </div>
          <div class="delete-scope delete-scope-kept">
            <h5>Will be kept</h5>
            <ul>
              <li>Audit history, including who released and who deletes this version</li>
              <li>Each device&#39;s own update history</li>
            </ul>
          </div>

          <div class="confirm-field" *ngIf="!isDeleteBlocked">
            <label for="deleteConfirmInput">Type <strong>{{ deleteTarget.version }}</strong> to confirm</label>
            <input id="deleteConfirmInput" class="confirm-input" type="text"
                   [class.confirm-input-match]="deleteConfirmState === 'match'"
                   autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" inputmode="text"
                   aria-describedby="deleteConfirmHint"
                   [attr.aria-invalid]="deleteInputInvalid ? 'true' : null"
                   [(ngModel)]="deleteConfirmInput"
                   (ngModelChange)="onDeleteConfirmInput()"
                   (focus)="onDeleteConfirmFocus($event)"
                   (keydown.enter)="submitDelete()"
                   [disabled]="isDeleting"
                   data-testid="delete-confirm-input" />
            <p id="deleteConfirmHint" class="confirm-match" [class.confirm-match-ok]="deleteConfirmState === 'match'"
               role="status" aria-live="polite" data-testid="delete-confirm-match">
              <span *ngIf="deleteConfirmState === 'match'" aria-hidden="true">&#10003; </span>{{ deleteConfirmHintText }}
            </p>
          </div>

          <p class="sr-only" role="status" aria-live="polite">
            <ng-container *ngIf="isDeleting">Deleting v{{ deleteTarget.version }}...</ng-container>
          </p>

          <div id="deleteErrorRegion" class="alert-error" role="alert" tabindex="-1" data-testid="delete-error" *ngIf="deleteErrorMessage">
            {{ deleteErrorMessage }}
          </div>
        </div>

        <div class="alertdialog-footer">
          <button type="button" id="btnCancelDelete" class="btn-cancel" (click)="closeDeleteDialog()"
                  [disabled]="isDeleting" data-testid="btn-cancel-delete">
            {{ isDeleteBlocked || deleteFailed ? 'Close' : 'Cancel' }}
          </button>
          <button type="button" class="btn-danger" *ngIf="!isDeleteBlocked" (click)="submitDelete()"
                  [disabled]="!canSubmitDelete" aria-describedby="deleteConfirmHint" data-testid="btn-confirm-delete">
            <span class="spinner-small" *ngIf="isDeleting"></span> {{ deleteCommitLabel }}
          </button>
        </div>
      </div>
    </div>

    <!-- Release to All Confirmation Dialog (AC-6) -->
    <div class="alertdialog-backdrop" *ngIf="showReleaseToAllDialog" role="alertdialog" aria-modal="true" aria-labelledby="releaseAllDialogTitle">
      <div class="alertdialog-box">
        <div class="alertdialog-header">
          <h4 id="releaseAllDialogTitle" class="confirm-title">🚀 Confirm Fleet-Wide Release</h4>
        </div>
        <div class="alertdialog-body">
          <p class="confirm-copy">
            Release v{{ pendingVersion?.version }} to all {{ confirmTotalActiveCount }} active Konobox devices?
          </p>
          <p class="confirm-subcopy" *ngIf="confirmTestMachineCount > 0">
            This release includes {{ confirmTestMachineCount }} test machines.
          </p>
          <p class="confirm-subcopy" *ngIf="confirmOfflineCount > 0">
            There are {{ confirmOfflineCount }} offline devices. The release will be stored and will apply when they reconnect.
          </p>

          <!-- Rollback Checkbox -->
          <div class="confirm-checkbox-block" *ngIf="bulkRollbackCount > 0">
            <label class="checkbox-label rollback-checkbox-label">
              <input type="checkbox" [(ngModel)]="confirmRollbackCheckbox" class="custom-checkbox" />
              <span>I understand this rolls back {{ bulkRollbackCount }} devices to an older version.</span>
            </label>
          </div>

          <!-- Force Checkbox & Warning Block -->
          <div class="force-alert-block" role="alert" *ngIf="pendingIsForce">
            <div class="force-alert-text">
              ⚠️ Force Update will re-download and re-install the package even if the hash matches. Force never overrides the apply gate.
            </div>
            <label class="checkbox-label force-checkbox-label">
              <input type="checkbox" [(ngModel)]="confirmForceCheckbox" class="custom-checkbox" />
              <span>I understand this forces a reinstall on all {{ confirmTotalActiveCount }} devices</span>
            </label>
          </div>
        </div>

        <div class="alertdialog-footer">
          <button type="button" id="btnCancelReleaseToAll" class="btn-cancel" (click)="cancelConfirmationDialogs()">
            Cancel
          </button>
          <button type="button" class="btn-submit" (click)="confirmReleaseToAll()" [disabled]="isReleaseToAllSubmitDisabled">
            Release v{{ pendingVersion?.version }} to all {{ confirmTotalActiveCount }} devices
          </button>
        </div>
      </div>
    </div>

    <!-- Bulk Rollback Confirmation Dialog (AC-5) -->
    <div class="alertdialog-backdrop" *ngIf="showBulkRollbackDialog" role="alertdialog" aria-modal="true" aria-labelledby="bulkRollbackTitle">
      <div class="alertdialog-box">
        <div class="alertdialog-header">
          <h4 id="bulkRollbackTitle" class="rollback-title">⚠️ Confirm Rollback to Selected Devices</h4>
        </div>
        <div class="alertdialog-body">
          <p class="rollback-copy">
            You are about to release v{{ pendingVersion?.version }} to {{ selectedDeviceCount }} selected devices. {{ bulkRollbackCount }} of the selected devices are currently on a newer version and will be rolled back.
          </p>
          <p class="rollback-subcopy" *ngIf="bulkUnknownDirectionCount > 0">
            {{ bulkUnknownDirectionCount }} devices have an unknown installed version and will be treated as standard releases.
          </p>
        </div>
        <div class="alertdialog-footer">
          <button type="button" id="btnCancelBulkRollback" class="btn-cancel" (click)="cancelConfirmationDialogs()">
            Cancel
          </button>
          <button type="button" class="btn-danger" (click)="confirmBulkRollback()">
            Roll back selected devices to v{{ pendingVersion?.version }}
          </button>
        </div>
      </div>
    </div>

    <!-- Slide-in Release Notes Drawer (AC-7) -->
    <div class="version-note-drawer" [class.open]="showReleaseNoteDrawer">
      <div class="drawer-header">
        <div class="drawer-title-group">
          <h4 class="drawer-title">
            <span class="drawer-header-icon">📝</span>
            Release Notes — v{{ selectedNoteVersion?.version }}
          </h4>
          <p class="drawer-subtitle" *ngIf="releaseNoteUpdatedAt">
            Updated {{ releaseNoteUpdatedAt | date:'medium' }}
            <span *ngIf="releaseNoteUpdatedBy">by {{ releaseNoteUpdatedBy }}</span>
          </p>
        </div>

        <div class="drawer-header-actions">
          <button type="button" class="btn-drawer-edit" *ngIf="!isEditingNote && !isLoadingNote && canReleaseDevice" (click)="startEditNote()" title="Edit Release Note">
            ✏️ Edit
          </button>
          <button type="button" class="drawer-close-btn" (click)="closeReleaseNotesDrawer()" title="Close Release Notes">✕</button>
        </div>
      </div>

      <div class="drawer-body">
        <div *ngIf="noteFeedbackMessage" class="alert-success drawer-alert">
          {{ noteFeedbackMessage }}
        </div>
        <div *ngIf="noteErrorMessage" class="alert-error drawer-alert">
          {{ noteErrorMessage }}
        </div>

        <!-- Note Loading -->
        <div *ngIf="isLoadingNote" class="drawer-loading-container">
          <div class="spinner"></div>
          <p class="drawer-loading-text">Loading release notes for v{{ selectedNoteVersion?.version }}...</p>
        </div>

        <!-- Note View Mode -->
        <div *ngIf="!isLoadingNote && !isEditingNote" class="drawer-view-section">
          <div *ngIf="releaseNoteContent" class="note-view-wrapper ql-snow">
            <div class="ql-editor note-view-editor" [innerHTML]="getSanitizedNote()"></div>
          </div>
          <div *ngIf="!releaseNoteContent" class="empty-note-state">
            <div class="empty-note-icon">📋</div>
            <h5 class="empty-note-title">No Release Note Available</h5>
            <p class="empty-note-desc">
              No release notes have been recorded for CoinSing Version {{ selectedNoteVersion?.version }} yet.
            </p>
            <button type="button" class="btn-create-note" *ngIf="canReleaseDevice" (click)="startEditNote()">
              ➕ Add Release Note
            </button>
          </div>
          <p class="drawer-immutable-notice">
            Release files cannot be changed. Only release notes can be edited.
          </p>
        </div>

        <!-- Note Edit Mode -->
        <div *ngIf="!isLoadingNote && isEditingNote" class="drawer-edit-section">
          <div class="editor-section-header">
            <span class="editor-section-label">Edit Formatted Release Notes:</span>
          </div>
          <div class="quill-editor-container">
            <quill-editor [(ngModel)]="releaseNoteContent" [modules]="quillConfig" placeholder="Type release highlights, bug fixes, or instructions...">
            </quill-editor>
          </div>
          <div class="drawer-edit-footer">
            <button type="button" class="btn-cancel-edit" (click)="cancelEditNote()" [disabled]="isSavingNote">
              Cancel
            </button>
            <button type="button" class="btn-save-note" (click)="saveReleaseNote()" [disabled]="isSavingNote">
              <span *ngIf="!isSavingNote">💾 Save Release Note</span>
              <span *ngIf="isSavingNote">
                <span class="spinner-small"></span> Saving...
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

